import type { InputHTMLAttributes } from "react";

export interface ToggleFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
}

/** A labelled on/off switch — the toggle vocabulary (e.g. remember-me on the login form). A native
 *  checkbox under the hood (`role="switch"`), token-styled as a sliding track + thumb. */
export function ToggleField({ label, ...rest }: ToggleFieldProps) {
  return (
    <label className="fui-toggle">
      <input type="checkbox" role="switch" className="fui-toggle__input" {...rest} />
      <span className="fui-toggle__track" aria-hidden="true">
        <span className="fui-toggle__thumb" />
      </span>
      <span className="fui-toggle__label">{label}</span>
    </label>
  );
}
